import React, { useMemo, useState } from 'react'
import DataTable, { TableColumn } from 'react-data-table-component'
import { customStyles_tabla } from 'components/constants'
import { PropsTableTitulosRegistrados, RowsTitulosRegistrados } from './TypesInformacionAcademica'
//Bootstrap
import { Form, FormCheck, Button, Row, Col } from "react-bootstrap"
import "./TableTitulos.scss"

const TableTitulosRegistrados = (props: PropsTableTitulosRegistrados) => {

    const [registroSenescyt, setregistroSenescyt] = useState<string>("")

    const checkBoxRegistro = (estadoRegistro:string,valorRegistro: string, valorStateRegistro: string) => {

        if (valorStateRegistro && valorRegistro === valorStateRegistro && estadoRegistro ==="NR") {
            return (
                <Form>
                    <Form.Check
                        defaultChecked = {true}
                        onChange={(e) => setregistroSenescyt("")}
                        type={"checkbox"}
                    />
                </Form>

            )
        }
        else if (valorStateRegistro && valorRegistro !== valorStateRegistro && valorRegistro === "R") {
            return (
                <div></div>
            )
        }
        else if (!valorStateRegistro && estadoRegistro === "NR") {
            return (
                <Form>
                    <Form.Check
                        onChange={(e) => setregistroSenescyt(valorRegistro)}
                        type={"checkbox"}
                    />
                </Form>
            )
        }

    }

    const columnasTitulos: TableColumn<RowsTitulosRegistrados>[] | undefined = useMemo(() => {
        if (props.data.length > 0) {
            return [
                {
                    name: "Nombre de titulo registrado",
                    selector: row => row.nombreTitulo,
                    sortable: true
                },
                {
                    name: "Fecha de Registro",
                    selector: row => row.fechaRegistro.toString(),
                },
                {
                    name:"Estado de Registro",
                    cell: row => row.estadoRegistroTitulo === "R" ? "REGISTRADO EN EL SISTEMA" : "AÚN SIN REGISTRAR"
                },
                {
                    name: "Acciones",
                    cell: (row) => { return (checkBoxRegistro(row.estadoRegistroTitulo,row.numeroRegistro, registroSenescyt)) },
                }
            ]
        }

    }, [props.data, registroSenescyt])

    if (columnasTitulos === undefined) {
        return (
            <div>No ha sido posible mostrar el contenido de la Tabla</div>
        )
    }


    function HandleClickButton(nregistro: string) {
        if (typeof (props.handleRegistro) === "function") {
            props.handleRegistro(nregistro);
            setregistroSenescyt("")
        }
    }




    return (
        <React.Fragment>
            <DataTable
                columns={columnasTitulos}
                data={props.data}
                striped
                customStyles={customStyles_tabla}
            />
            <Row className="justify-content-center">
                <Col className="text-align-center" xs={12} md={2}>
                    {
                        registroSenescyt !== "" &&
                        (
                            <Button className="btnEspolPrimary butonAgregarTitulo" type="button" onClick={() => { HandleClickButton(registroSenescyt) }}>Agregar</Button>
                        )
                    }
                </Col>
            </Row>
          

        </React.Fragment>

    )


}
export default TableTitulosRegistrados